import {
  EyeStroke,
  FileMultipleStroke,
  FilePlusCircleStroke,
  Pencil1Stroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { TEMPLATE_BASE64 as excelTemplate_danh_muc_ke_toan_phi_Danh_m_c_ph_ } from '@/lib/templates-base64/DMPHI';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';
import { downloadBase64Excel } from '@/lib/template-downloader';

/**
 * Props for the ActionBar component
 */
interface ActionBarProps {
  isViewDisabled?: boolean;
  onAddClick?: () => void;
  onEditClick?: () => void;
  onDeleteClick?: () => void;
  onCopyClick?: () => void;
  onViewClick?: () => void;
  onRefreshClick?: () => void;
  onFixedColumnsClick?: () => void;
  onExportClick?: () => void;
  onImportExcel?: () => void;
}

/**
 * ActionBar component for the Balance Sheet by Unit page
 */
const ActionBar: React.FC<ActionBarProps> = ({
  isViewDisabled = false,
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onViewClick,
  onFixedColumnsClick,
  onRefreshClick,
  onExportClick,
  onImportExcel
}) => {
  const handleDownloadTemplate = () => {
    downloadBase64Excel(excelTemplate_danh_muc_ke_toan_phi_Danh_m_c_ph_, 'Danh mục phí.xlsx');
  };

  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục phí</h1>}>
      {onAddClick && <ActionButtonV2 icon={FilePlusCircleStroke} title='Thêm' onClick={onAddClick} />}
      {onEditClick && (
        <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isViewDisabled} />
      )}
      {onDeleteClick && (
        <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteClick} disabled={isViewDisabled} />
      )}
      {onCopyClick && (
        <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyClick} disabled={isViewDisabled} />
      )}
      {onViewClick && <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={isViewDisabled} />}

      <MenuButtonV2
        title='Khác'
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshClick,
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: onFixedColumnsClick,
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={555} />,
            onClick: onExportClick,
            group: 1
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: handleDownloadTemplate,
            group: 2
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: onImportExcel,
            group: 2
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
